$(document).ready(function () {

  $('.scroll-top-btn').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 800);
  });

  $('div.mobile-facets__details[data-index="mobile-3"] ul.facets-layout li:gt(4)').remove();

  var $slider = $('.video-slides-block');
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: false,
    dots: true,
    infinite: true,
    autoplay: false,
    nextArrow: '<div class="video-slide next-video"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.282573 1.68781C0.192325 1.59231 0.121771 1.47996 0.0749407 1.35719C0.0281096 1.23442 0.00591755 1.10363 0.00963306 0.972287C0.0133486 0.840941 0.0428982 0.711614 0.0965948 0.591688C0.150291 0.471763 0.227083 0.363588 0.322586 0.27334C0.418088 0.183092 0.530432 0.112538 0.653202 0.065707C0.775971 0.018876 0.906761 -0.00331544 1.03811 0.000400135C1.16945 0.00411571 1.29878 0.0336653 1.41871 0.0873618C1.53863 0.141058 1.64681 0.21785 1.73705 0.313353L10.2399 9.31634C10.4155 9.50207 10.5133 9.74797 10.5133 10.0036C10.5133 10.2592 10.4155 10.5051 10.2399 10.6908L1.73705 19.6948C1.6474 19.7924 1.53925 19.8712 1.41889 19.9266C1.29852 19.9821 1.16833 20.013 1.0359 20.0177C0.903459 20.0224 0.771405 20.0008 0.647408 19.954C0.523409 19.9073 0.409938 19.8363 0.313585 19.7454C0.217234 19.6544 0.139919 19.5451 0.0861349 19.424C0.0323515 19.3029 0.00316906 19.1723 0.000284195 19.0398C-0.00260162 18.9073 0.0208673 18.7756 0.0693274 18.6522C0.117787 18.5289 0.190272 18.4164 0.282573 18.3213L8.13718 10.0036L0.282573 1.68781Z" fill="white"/></svg></div>',
    prevArrow: '<div class="video-slide prev-video"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.2307 1.68781C10.321 1.59231 10.3915 1.47996 10.4384 1.35719C10.4852 1.23442 10.5074 1.10363 10.5037 0.972287C10.5 0.840941 10.4704 0.711614 10.4167 0.591688C10.363 0.471763 10.2862 0.363588 10.1907 0.27334C10.0952 0.183092 9.98287 0.112538 9.8601 0.065707C9.73733 0.018876 9.60654 -0.00331544 9.4752 0.000400135C9.34385 0.00411571 9.21453 0.0336653 9.0946 0.0873618C8.97467 0.141058 8.8665 0.21785 8.77625 0.313353L0.273433 9.31634C0.0978387 9.50207 0 9.74797 0 10.0036C0 10.2592 0.0978387 10.5051 0.273433 10.6908L8.77625 19.6948C8.8659 19.7924 8.97405 19.8712 9.09442 19.9266C9.21479 19.9821 9.34497 20.013 9.47741 20.0177C9.60985 20.0224 9.7419 20.0008 9.8659 19.954C9.9899 19.9073 10.1034 19.8363 10.1997 19.7454C10.2961 19.6544 10.3734 19.5451 10.4272 19.424C10.481 19.3029 10.5101 19.1723 10.513 19.0398C10.5159 18.9073 10.4924 18.7756 10.444 18.6522C10.3955 18.5289 10.323 18.4164 10.2307 18.3213L2.37613 10.0036L10.2307 1.68781Z" fill="white"/></svg></div>'
  });

  $(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
      $('.section-header').addClass('stickyheader');
    } else {
      $('.section-header').removeClass('stickyheader');
    }
  });

  function getActiveVideo($slide) {
  if (!$slide || !$slide.length) {
    return null;
  }

  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var video = null;

  if (isMobile) {
    video = $slide.find('.mobile-video video').get(0);

    if (!video) {
      video = $slide.find('.desktop-video video').get(0);
    }
  } else {
    video = $slide.find('.desktop-video video').get(0);

    if (!video) {
      video = $slide.find('.mobile-video video').get(0);
    }
  }

  return video || null;
}

  /**
   * Pause and reset every video.
   */
  function pauseAllVideos() {
    $slider.find('video').each(function () {
      this.pause();
      try {
        this.currentTime = 0;
      } catch (e) {}
      $(this).off('ended.videoSlide');
    });
  }

  /**
   * Play video for the active ORIGINAL Slick slide.
   */
  function playActiveVideo(slideIndex) {
  pauseAllVideos();

  var slick = $slider.slick('getSlick');

  if (!slick || !slick.$slides || !slick.$slides.length) {
    return;
  }

  // Keep the index within the original slide range
  slideIndex = parseInt(slideIndex, 10) || 0;

  if (slideIndex < 0 || slideIndex >= slick.$slides.length) {
    slideIndex = 0;
  }

  var $activeSlide = slick.$slides.eq(slideIndex);

  if (!$activeSlide.length) {
    return;
  }

  var activeVideo = getActiveVideo($activeSlide);

  // No video found in this slide
  if (!activeVideo) {
    return;
  }

  try {
    activeVideo.currentTime = 0;
  } catch (e) {}

  // Make sure video is muted for autoplay
  activeVideo.muted = true;
  activeVideo.playsInline = true;

  var playPromise = activeVideo.play();

  if (playPromise !== undefined) {
    playPromise.catch(function (error) {
      console.log('Video play error:', error);
    });
  }

  $(activeVideo).off('ended.videoSlide')
    .on('ended.videoSlide', function () {
      $slider.slick('slickNext');
    });
}
  $slider.on('init', function (event, slick) {
  playActiveVideo(slick.currentSlide);
});

  /**
   * Before changing slide
   */
  $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var $currentSlide = slick.$slides.eq(currentSlide);
    var currentVideo = getActiveVideo($currentSlide);
    if (currentVideo) {
      currentVideo.pause();
      try {
        currentVideo.currentTime = 0;
      } catch (e) {}
      $(currentVideo).off('ended.videoSlide');
    }
  });

  /**
   * After changing slide
   */
  $slider.on('afterChange', function (event, slick, currentSlide) {
    playActiveVideo(currentSlide);
  });

  /**
   * If user resizes from desktop <-> mobile,
   * restart the correct video.
   */
  var lastIsMobile = window.matchMedia('(max-width: 749px)').matches;
  $(window).on('resize', function () {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile !== lastIsMobile) {
      lastIsMobile = isMobile;
      var slick = $slider.slick('getSlick');
      playActiveVideo(slick.currentSlide);
    }
  });

  var productSliderOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    speed: 300,
    prevArrow: '<button class="img-arrow img-prev" type="button">' +
      '<svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M10.2307 1.68781C10.321 1.59231 10.3915 1.47996 10.4384 1.35719C10.4852 1.23442 10.5074 1.10363 10.5037 0.972287C10.5 0.840941 10.4704 0.711614 10.4167 0.591688C10.363 0.471763 10.2862 0.363588 10.1907 0.27334C10.0952 0.183092 9.98287 0.112538 9.8601 0.065707C9.73733 0.018876 9.60654 -0.00331544 9.4752 0.000400135C9.34385 0.00411571 9.21453 0.0336653 9.0946 0.0873618C8.97467 0.141058 8.8665 0.21785 8.77625 0.313353L0.273433 9.31634C0.0978387 9.50207 0 9.74797 0 10.0036C0 10.2592 0.0978387 10.5051 0.273433 10.6908L8.77625 19.6948C8.8659 19.7924 8.97405 19.8712 9.09442 19.9266C9.21479 19.9821 9.34497 20.013 9.47741 20.0177C9.60985 20.0224 9.7419 20.0008 9.8659 19.954C9.9899 19.9073 10.1034 19.8364 10.1997 19.7454C10.2961 19.6544 10.3734 19.5451 10.4272 19.424C10.481 19.3029 10.5101 19.1723 10.513 19.0398C10.5159 18.9073 10.4924 18.7756 10.444 18.6522C10.3955 18.5289 10.323 18.4164 10.2307 18.3213L2.37613 10.0036L10.2307 1.68781Z" fill="black"/>' +
      '</svg>' +
    '</button>',
    nextArrow: '<button class="img-arrow img-next" type="button"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L10 10.5L1 20" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: window.swipe === 'arrows',
          dots: window.swipe === 'dots'
        }
      }
    ]
  };

  function initProductSliders($container) {
    var $sliders = $container ? $container.find('.pdp-img-sliders:not(.search-pdp-slider)') : $('.pdp-img-sliders:not(.search-pdp-slider)');
    $sliders.each(function (){
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) {
        refreshProductSlider($slider);
        return;
      }
      if (!$slider.find('.product-image-slide').length) {
        return;
      }
      if (!$slider.data('original-color-slides')) {
        $slider.data('original-color-slides', $slider.find('.product-image-slide').clone(true, true));
      }

      $slider.slick(productSliderOptions);
      refreshProductSlider($slider);

      $slider.find('img').each(function () {
        if (this.complete) {
          return;
        }

        $(this).one('load', function () {
          refreshProductSlider($slider);
        });

      });

    });
  }

  function initSearchProductSliders() {
    var $searchSliders = $(".main-product-card .search-pdp-slider");
    if (!$searchSliders.length) {
      return;
    }
    $searchSliders.each(function () {
        var $slider = $(this);
        if ($slider.hasClass("slick-initialized")) {
          return;
        }
        if (!$slider.find(".product-image-slide").length) {
          return;
        }
        var $card = $slider.closest(".product-card");
        var $originalSlides =
          $slider.data("original-color-slides");
        if (!$originalSlides || !$originalSlides.length) {
          $originalSlides = $slider.find(".product-image-slide").clone(true, true);
          $slider.data("original-color-slides", $originalSlides);
        }
        var $activeSwatch =
            $card.find(".color-swatch.active_shade").first();
        if (!$activeSwatch.length) {
          console.log("SEARCH: no active swatch");
          var $initialSlides = $originalSlides;
          var initialImageLimit = getProductImageLimit();
          if (initialImageLimit !== null && $initialSlides.length > initialImageLimit) {
              $initialSlides = $initialSlides.slice(0, initialImageLimit);
          }
          $slider.empty();
          $initialSlides.each(function () {
              $slider.append($(this).clone(true, true));
          });
          $slider.slick(productSliderOptions);
          setTimeout(function () {
              if ($slider.hasClass("slick-initialized")) {
                  $slider.slick("setPosition");
              }
          }, 100);
          return;
        }
        var selectedColor =
            String($activeSwatch.attr("data-color") || "")
                .toLowerCase().trim();
        console.log("SEARCH INITIAL COLOR:", selectedColor);
        var $filteredSlides =
            $originalSlides.filter(function () {
                var slideColor = String($(this).attr("data-color") || "")
                    .toLowerCase().trim();
                return slideColor === selectedColor;
            });
        console.log("SEARCH:", selectedColor, "matching images:", $filteredSlides.length);
        if (!$filteredSlides.length) {
            console.log("SEARCH: no images for", selectedColor, "- showing ALL images");
            $filteredSlides = $originalSlides;
        }
        var imageLimit =
            getProductImageLimit();
        if (imageLimit !== null && $filteredSlides.length > imageLimit) {
            console.log("SEARCH IMAGE LIMIT:", imageLimit);
            $filteredSlides = $filteredSlides.slice(0, imageLimit);
        }
        $slider.empty();
        $filteredSlides.each(function () {
            $slider.append($(this).clone(true, true));
        });
        requestAnimationFrame(
            function () {
                requestAnimationFrame(function () {
                    var sliderWidth = $slider.outerWidth();
                    console.log("SEARCH INITIAL SLIDER WIDTH:", sliderWidth);
                    if (!sliderWidth || sliderWidth <= 1) {
                        setTimeout(function () {
                            initSearchProductSliders();
                        }, 150);
                        return;
                    }
                    if (
                        !$slider.hasClass("slick-initialized")
                    ) {
                        $slider.slick(productSliderOptions);
                    }
                    $slider.slick("setPosition");
                    $slider
                        .find("img")
                        .each(function () {
                            var img = this;
                            if (img.complete) {
                                return;
                            }
                            $(img).one("load", function () {
                                if ($slider.hasClass("slick-initialized")) {
                                    $slider.slick("setPosition");
                                }
                            });
                        });
                });
            }
        );
    });
}


  function refreshProductSlider($slider) {
    if (!$slider.length) {
      return;
    }
    requestAnimationFrame(function () {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    });
    setTimeout(function () {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    }, 100);
    setTimeout(function () {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    }, 500);
  }

  $(function () {
    initProductSliders();
    initSearchProductSliders();
  });

  $(window).on('load', function () {
    initProductSliders();
    initSearchProductSliders();
  });

  var searchProductObserver = new MutationObserver(function (mutations) {
    var hasSearchProducts = false;
    mutations.forEach(function (mutation) {
      if (!mutation.addedNodes || !mutation.addedNodes.length) {
        return;
      }
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 &&
          (
            $(node).find('.main-product-card').length ||
            $(node).hasClass('main-product-card')
          )) {
          hasSearchProducts = true;
        }
      });
    });

    if (!hasSearchProducts) {
      return;
    }

    clearTimeout(window.searchSliderTimer);
    window.searchSliderTimer = setTimeout(function () {
      initSearchProductSliders();
    }, 200);
  });

  searchProductObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  $('.banner-slides-block').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: false
  });

  function filterSearchProductImages($slider, selectedColor) {
    if (!$slider.length) {
      return;
    }

    selectedColor = String(selectedColor || '').toLowerCase().trim();
    var $originalSlides = $slider.data('original-color-slides');

    if (!$originalSlides || !$originalSlides.length) {
      if ($slider.hasClass('slick-initialized')) {
        $originalSlides = $slider.find('.slick-slide').not('.slick-cloned')
          .find('.product-image-slide').clone(true, true);
      } else {
        $originalSlides = $slider.find('.product-image-slide').clone(true, true);
      }

      $slider.data('original-color-slides',$originalSlides);
    }

    var $filteredSlides = $originalSlides.filter(function () {
      var slideColor = String($(this).attr('data-color') || '').toLowerCase().trim();
      return slideColor === selectedColor;
    });

    if (!$filteredSlides.length) {
      console.log('Search: no images for', selectedColor,'- showing all images');
      $filteredSlides = $originalSlides;
    }

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    $slider.empty();
    $filteredSlides.each(function () {
      $slider.append($(this).clone(true, true));
    });

    if ($slider.find('.product-image-slide').length) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!$slider.hasClass('slick-initialized')) {
            $slider.slick(productSliderOptions);
          }
          $slider.slick('setPosition');
          $slider.find('img').each(function () {
            var img = this;
            if (img.complete) {
              setTimeout(function () {
                if ($slider.hasClass('slick-initialized')) {
                  $slider.slick('setPosition');
                }
              }, 50);
            } else {
              $(img).one('load', function () {
                if ($slider.hasClass('slick-initialized')) {
                  $slider.slick('setPosition');
                }
              });
            }
          });
        });
      });
    }
  }

  $(document).on('click', '.color-swatch', function (e) {
    e.preventDefault();
    var $swatch = $(this);
    var $card = $swatch.closest('.product-card');

    if (!$card.length) {
      return;
    }

    var $slider = $card.find('.product-image-slider').first();
    if (!$slider.length) {
      return;
    }

    var selectedColor = String($swatch.attr('data-color') || '').toLowerCase().trim();
    var variantUrl = $swatch.attr('data-variant-url') || '';

    function getImageLimit() { 
      if (!window.enable_img_limiter) { 
        return null; 
      } 
      var limit = parseInt( window.img_limit, 10 ); 
      if ( isNaN(limit) || limit < 1 ) { 
        return null; 
      } 
      return limit; 
    }

    /*
    * =================================================
    * ACTIVE SWATCH
    * =================================================
    */

    $card.find('.color-swatch').removeClass('active_shade');
    $swatch.addClass('active_shade');

    /*
    * =================================================
    * SAVE ORIGINAL SLIDES
    * =================================================
    */

    var $originalSlides = $slider.data('original-color-slides');
    if (!$originalSlides || !$originalSlides.length) {

      if ($slider.hasClass('slick-initialized')) {

        /*
        * Slick structure:
        *
        * .slick-slide
        *    .product-image-slide
        *
        * Get only real slides.
        */
        $originalSlides = $slider
          .find('.slick-slide')
          .not('.slick-cloned')
          .find('.product-image-slide')
          .clone(true, true);

      } else {
        $originalSlides = $slider
          .children('.product-image-slide')
          .clone(true, true);
      }

      if ($originalSlides.length) {
        $slider.data(
          'original-color-slides',
          $originalSlides
        );
      }
    }

    if (!$originalSlides || !$originalSlides.length) {
      return;
    }

    /*
    * =================================================
    * FILTER IMAGES
    * =================================================
    */

    var $filteredSlides = $originalSlides.filter(function () {

      var slideColor = String(
        $(this).attr('data-color') || ''
      ).toLowerCase().trim();

      return slideColor === selectedColor;

    });

    /*
    * If selected color has no images,
    * show all original images.
    */
    if (!$filteredSlides.length) {
      $filteredSlides = $originalSlides;
    }

    var imageLimit = getImageLimit();

    if (imageLimit && $filteredSlides.length > imageLimit) {
      $filteredSlides = $filteredSlides.slice(0, imageLimit);
    }


    /*
    * =================================================
    * PREVENT UNNECESSARY REBUILD
    * =================================================
    */

    var currentColor = $slider.attr('data-current-color');
    if (currentColor === selectedColor) {

      /*
      * Still update the URL.
      */
      if (variantUrl) {

        $card
          .find('.product-title a')
          .attr('href', variantUrl)
          .prop('href', variantUrl);

        $card
          .find('.more-colors a')
          .attr('href', variantUrl)
          .prop('href', variantUrl);
      }

      return;
    }

    $slider.attr(
      'data-current-color',
      selectedColor
    );

    /*
    * =================================================
    * HIDE SLIDER DURING REBUILD
    * =================================================
    *
    * This is the important part.
    *
    * We don't allow the browser to paint the
    * uninitialised images.
    */
    $slider.css('visibility', 'hidden');

    /*
    * =================================================
    * DESTROY CURRENT SLICK
    * =================================================
    */

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    /*
    * =================================================
    * BUILD NEW SLIDES
    * =================================================
    */

    var $newSlides = $filteredSlides.clone(true, true);

    /*
    * Replace everything in ONE operation.
    */
    $slider.empty();
    $slider.append($newSlides);

    /*
    * =================================================
    * INITIALIZE SLICK IMMEDIATELY
    * =================================================
    */

    if ($newSlides.length > 1) {

      if ($card.closest('.most-loved-sec').length) {

        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          dots: true,
          prevArrow: '<button class="img-arrow img-prev" type="button">' +
      '<svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M10.2307 1.68781C10.321 1.59231 10.3915 1.47996 10.4384 1.35719C10.4852 1.23442 10.5074 1.10363 10.5037 0.972287C10.5 0.840941 10.4704 0.711614 10.4167 0.591688C10.363 0.471763 10.2862 0.363588 10.1907 0.27334C10.0952 0.183092 9.98287 0.112538 9.8601 0.065707C9.73733 0.018876 9.60654 -0.00331544 9.4752 0.000400135C9.34385 0.00411571 9.21453 0.0336653 9.0946 0.0873618C8.97467 0.141058 8.8665 0.21785 8.77625 0.313353L0.273433 9.31634C0.0978387 9.50207 0 9.74797 0 10.0036C0 10.2592 0.0978387 10.5051 0.273433 10.6908L8.77625 19.6948C8.8659 19.7924 8.97405 19.8712 9.09442 19.9266C9.21479 19.9821 9.34497 20.013 9.47741 20.0177C9.60985 20.0224 9.7419 20.0008 9.8659 19.954C9.9899 19.9073 10.1034 19.8364 10.1997 19.7454C10.2961 19.6544 10.3734 19.5451 10.4272 19.424C10.481 19.3029 10.5101 19.1723 10.513 19.0398C10.5159 18.9073 10.4924 18.7756 10.444 18.6522C10.3955 18.5289 10.323 18.4164 10.2307 18.3213L2.37613 10.0036L10.2307 1.68781Z" fill="black"/>' +
      '</svg>' +
    '</button>',
    nextArrow: '<button class="img-arrow img-next" type="button"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L10 10.5L1 20" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: window.swipe === 'arrows',
                dots: window.swipe === 'dots'
              }
            }
          ]
        });

      } else {

        /*
        * All other product sliders keep the existing
        * global slider configuration.
        */
        $slider.slick(productSliderOptions);

      }

      /*
      * Force correct dimensions immediately.
      */
      $slider.slick('setPosition');

    }

    /*
    * =================================================
    * SHOW SLIDER
    * =================================================
    *
    * Slick has now taken control of the DOM.
    */
    $slider.css('visibility', '');

    /*
    * =================================================
    * UPDATE PRODUCT LINKS
    * =================================================
    */

    if (variantUrl) {

      $card
        .find('.product-title a')
        .attr('href', variantUrl)
        .prop('href', variantUrl);

      $card
        .find('.product-image-slide a')
        .attr('href', variantUrl)
        .prop('href', variantUrl);

      $card
        .find('.more-colors a')
        .attr('href', variantUrl)
        .prop('href', variantUrl);
    }

    /*
    * =================================================
    * REFRESH AFTER IMAGE LOAD
    * =================================================
    */

    $slider.find('img').each(function () {

      var img = this;

      if (img.complete) {

        /*
        * Don't use setTimeout here.
        */
        requestAnimationFrame(function () {

          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('setPosition');
          }

        });

      } else {

        $(img).one('load', function () {

          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('setPosition');
          }

        });

      }

    });

  });

  if ($(window).width() < 750) {
    $('.mobile-facets__details').removeAttr('open');
  }

  $(document).on('click', '.mobile-facets__summary', function (e) {
    e.preventDefault();
    var $details = $(this).closest('.mobile-facets__details');

    if ($details.attr('open')) {
      $details.removeAttr('open');
    } else {
      $('.mobile-facets__details').removeAttr('open');
      $details.attr('open', 'open');
    }
  });

  function initializeReadMore() {
    var maxHeight = 80;
    $('.rmrl-wrapper').each(function () {
      var $wrapper = $(this);
      var $content = $wrapper.find('.rmrl-content');
      var $button = $wrapper.find('.rmrl-toggle');

      if (!$content.length || !$button.length) return;
      $content.removeClass('expanded');
      $content.stop(true, true);
      var fullHeight = $content[0].scrollHeight;

      if (fullHeight > maxHeight) {
        $content.css({
          'max-height': maxHeight + 'px',
          'overflow': 'hidden'
        });
        $button.show();
        $button.text('Read More');
      } else {
        $content.css({
          'max-height': 'none',
          'overflow': 'visible'
        });
        $button.hide();
      }
    });
  }

  initializeReadMore();
  $('.faq-items').hide();

  $('.faq-category-title').on('click', function () {
    const $category = $(this).closest('.faq-category');
    const heading = $(this).html();
    const faqContent = $category.find('.faq-items').html();
    $('.selected_tab_info').html(`<h2 class="faq-category-title">${heading}</h2><div class="faq-items">${faqContent}</div>`);
    $('.selected_tab').removeClass('hidden');
    $('.contact-form-body-area').hide();
    $(".contact-form-top-head").addClass("hidden");
  });

  $('.back-to-faq').on('click', function () {
    $('.selected_tab_info').empty();
    $('.selected_tab').addClass('hidden');
    $('.contact-form-body-area').show();
    $(".contact-form-top-head").removeClass("hidden");
  });

  $(document).on('click', '.selected_tab_info summary', function (e) {
    e.preventDefault();
    const $details = $(this).parent();
    $details.prop('open', !$details.prop('open'));
  });

  const params = new URLSearchParams(window.location.search);
  const targetQuestion = params.get('question');

  let found = false;
  $('.faq-category').each(function () {
    const $category = $(this);
    $category.find('details').each(function () {
      const $details = $(this);
      const question = $details.find('summary').first().text().trim();
      if (question === targetQuestion) {
        found = true;
        const heading = $category.find('.faq-category-title').html();
        const faqContent = $category.find('.faq-items').html();
        $('.selected_tab_info').html(`<h2 class="faq-category-title">${heading}</h2><div class="faq-items">${faqContent}</div>`);
        $('.selected_tab').removeClass('hidden');
        $('.contact-form-body-area').hide();
        $('.contact-form-top-head').addClass('hidden');

        // wait until html is inserted
        setTimeout(function () {
          $('.selected_tab_info details').each(function () {
            const summaryText = $(this).find('summary').first().text().trim();
            if (summaryText === targetQuestion) {
              $(this).attr('open', true);
              $('html, body').animate({
                  scrollTop: $(this).offset().top - 100
              }, 500);

              window.history.replaceState({}, document.title, window.location.pathname);
            }
          });
        }, 100);
        return false;
      }
    });
    if (found) return false;
  });

  function sortColorFacets() {
    const list = document.querySelector('div.mobile-facets__details[data-index="mobile-1"] ul.facets-layout');
    if (!list) return;
    const items = [...list.querySelectorAll("li.mobile-facets__item")];
    items.sort((a, b) => {
        const aText = a.querySelector(".facet-checkbox__text-label").textContent.trim();
        const bText = b.querySelector(".facet-checkbox__text-label").textContent.trim();
        return aText.localeCompare(bText);
    });
    items.forEach(item => list.appendChild(item));
  }

  $(document).on("click", ".mobile-facets__open", function () {
    setTimeout(sortColorFacets, 100);
  });

  let gallerySwiper;
  let galleryOwnsScroll = false;
  let galleryLocked = false;
  let galleryReady = false;
  let galleryPosition = 0;
  let galleryTarget = 0;
  let galleryFrame = false;
  let galleryEnteredFromBottom = false;
  let galleryReleaseCount = 0;
  let galleryReleasedAtTop = false;

  function getProductImageLimit() { 
    if (!window.enable_img_limiter) { 
      return null; 
    } 
    var limit = parseInt( window.img_limit, 10 ); 
    if ( isNaN(limit) || limit < 1 ) { 
      return null; 
    } 
    return limit; 
  } 

    function shouldControlGallery() {
        if (!gallerySwiper) return false;
        const gallery = document.querySelector('.gallery-slider');
        if (!gallery) return false;
        const rect = gallery.getBoundingClientRect();

        // gallery is visible in viewport
        return (rect.top <= 10 && rect.bottom >= window.innerHeight - 10);
    }

    const gallerySection = document.querySelector(".product__media-wrapper");

    function galleryIsActive() {
        if (!gallerySection) return false;
        const rect = gallerySection.getBoundingClientRect();
        return (rect.top <= 0 && rect.bottom >= window.innerHeight);
    }

    // --------------------------------
    // LOAD GALLERY BY COLOR
    // --------------------------------
    function loadGallery(color) {
        const wrapper = document.querySelector('.gallery-slider .swiper-wrapper');
        if (!wrapper) return;
        // Save original slides once
        if (!wrapper.dataset.loaded) {
            window.originalSlides = [
                ...wrapper.children
            ].map(slide => slide.cloneNode(true));
            wrapper.dataset.loaded = "true";
        }
        if (gallerySwiper) {
            gallerySwiper.destroy(true, true);
            gallerySwiper = null;
        }
        wrapper.innerHTML = "";
        const selectedColor = color.trim().toLowerCase();

        const filteredSlides = window.originalSlides.filter(slide => {
            return (slide.dataset.alt && slide.dataset.alt.trim().toLowerCase() === selectedColor);
        });

        // If no images found for selected color, show all images
        let slidesToRender = filteredSlides.length ? filteredSlides : window.originalSlides;

        slidesToRender.forEach(slide => {
            wrapper.appendChild(slide.cloneNode(true));
        });

        initGallery();
        window.addEventListener("load", function(){
            if(gallerySwiper){
                const maxScroll = gallerySwiper.wrapperEl.scrollHeight - window.innerHeight;
                galleryPosition = 0;
                galleryTarget = 0;
            }
        });
    }

    // --------------------------------
    // INIT SWIPER
    // --------------------------------
    function initGallery() {

        if (gallerySwiper) {
            gallerySwiper.destroy(true, true);
            gallerySwiper = null;
        }

        // Clear old pagination bullets
        const pagination = document.querySelector('.swiper-pagination');
        if (pagination) {
            pagination.innerHTML = "";
        }

        gallerySwiper = new Swiper('.gallery-slider', {
            direction: window.innerWidth < 768 ? 'horizontal' : 'vertical',
            loop: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            autoHeight: false,
            observer: true,
            observeParents: true,
            zoom: window.innerWidth < 768 ? {
                maxRatio: 3,
                minRatio: 1,
                toggle: true
            } : false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets',
                dynamicBullets: false
            }
        });

        if (!gallerySwiper || !gallerySwiper.wrapperEl) {
            gallerySwiper = null;
            galleryReady = false;
            return;
        }

        requestAnimationFrame(() => {
            if (!gallerySwiper || !gallerySwiper.wrapperEl) return;
            const slider = gallerySwiper.el;
            const wrapper = gallerySwiper.wrapperEl;
            slider.style.removeProperty("overflow");
            wrapper.style.removeProperty("height");
            wrapper.style.removeProperty("min-height");

            gallerySwiper.slides.forEach(slide => {
                slide.style.removeProperty("height");
                slide.style.removeProperty("min-height");
                slide.style.height = "100vh";
            });

            gallerySwiper.update();
        });

        galleryReady = true;
        galleryTarget = 0;
        galleryPosition = 0;
        gallerySwiper.wrapperEl.style.transform = "translate3d(0,0,0)";
    }

    // --------------------------------
    // REMOVE SWIPER HEIGHTS
    // --------------------------------
    function removeSwiperHeights(){
        const swiperEl = document.querySelector('.gallery-slider');
        const wrapper = document.querySelector('.gallery-slider .swiper-wrapper');
        if(swiperEl){
            swiperEl.style.removeProperty('height');
        }
        if(wrapper){
            wrapper.style.removeProperty('height');
        }
        document.querySelectorAll('.gallery-slider .swiper-slide').forEach(slide=>{
            slide.style.removeProperty('height');
        });
    }

    // --------------------------------
    // INIT
    // --------------------------------
    initGallery();
    window.addEventListener("load", function(){
        if(gallerySwiper){
            const maxScroll = gallerySwiper.wrapperEl.scrollHeight - window.innerHeight;
            galleryPosition = 0;
            galleryTarget = 0;
        }
    });

    function updateGalleryActiveSlide(){
        if(!gallerySwiper) return;
        const slides = gallerySwiper.slides;
        const viewportCenter = galleryPosition + (window.innerHeight / 2);
        let activeIndex = 0;
        slides.forEach((slide, index)=>{
            const slideStart = slide.offsetTop;
            const slideEnd = slideStart + slide.offsetHeight;
            // When viewport center is inside slide
            if(viewportCenter >= slideStart && viewportCenter <= slideEnd){
                activeIndex = index;
            }
        });

        if(gallerySwiper.activeIndex !== activeIndex){
            gallerySwiper.activeIndex = activeIndex;
            gallerySwiper.pagination.update();
            document.querySelectorAll('.swiper-pagination-bullet').forEach((bullet,index)=>{
                bullet.classList.toggle('swiper-pagination-bullet-active', index === activeIndex);
            });
        }
    }

    function updateGalleryEnd(){

        if(!gallerySwiper) return;

        const info = document.querySelector('.product__info-container');
        const maxScroll = Math.max(0, gallerySwiper.wrapperEl.scrollHeight - window.innerHeight);
        if(galleryTarget >= maxScroll - 5){
            info.classList.add("gallery-end");
        }else{
            info.classList.remove("gallery-end");
        }
    }

    // --------------------------------
    // SMOOTH CONTINUOUS SCROLL
    // --------------------------------
    function animateGalleryScroll(){
        if(!gallerySwiper) return;
        const wrapper = gallerySwiper.wrapperEl;
        const maxScroll = wrapper.scrollHeight - window.innerHeight;
        galleryTarget = Math.max(0, Math.min(galleryTarget, maxScroll));

        // Reset release flag once we're no longer at the end
        if (galleryTarget < maxScroll - 5) {
            galleryReleaseCount = 0;
        }

        if(galleryTarget >= maxScroll){
            galleryTarget = maxScroll;
        }

        if(galleryTarget <= 0){
            galleryTarget = 0;
        }

        galleryPosition += (galleryTarget - galleryPosition) * 0.28;
        wrapper.style.transform = `translate3d(0,-${galleryPosition}px,0)`;
        updateGalleryActiveSlide();
        updateGalleryEnd();

        if(Math.abs(galleryTarget - galleryPosition) > 0.5){
            requestAnimationFrame(animateGalleryScroll);
        }else{
            galleryFrame = false;
        }
    }

    function isGalleryReverseVisible() {
        if (!gallerySection) return false;
        const rect = gallerySection.getBoundingClientRect();
        const viewportTop = 0;
        const viewportBottom = window.innerHeight;
        const visibleTop = Math.max(rect.top, viewportTop);
        const visibleBottom = Math.min(rect.bottom, viewportBottom);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const sectionHeight = rect.height;
        if (sectionHeight <= 0) {
            return false;
        }

        const visibleRatio = visibleHeight / sectionHeight;

        /*
        * Must have at least 50% of the actual
        * product media section visible.
        */
        return (
            rect.bottom > viewportTop &&
            rect.top < viewportBottom &&
            visibleRatio >= 0.50
        );
    }

    document.addEventListener("wheel", function (e) {

        if (window.innerWidth < 768) return;
        if (!gallerySwiper) return;

        const gallerySection = document.querySelector(".product__media-wrapper");
        if (!gallerySection) return;

        const wrapper = gallerySwiper.wrapperEl;
        if (!wrapper) return;

        /*
        * =====================================================
        * BASIC VALUES
        * =====================================================
        */

        const maxScroll =
            Math.max(
                0,
                wrapper.scrollHeight - window.innerHeight
            );

        const isDown = e.deltaY > 0;
        const isUp = e.deltaY < 0;

        const delta = Math.min(Math.abs(e.deltaY), 80) * 1.4;

        /*
        * =====================================================
        * GALLERY POSITION
        * =====================================================
        */

        const atTop =
            galleryTarget <= 2 &&
            galleryPosition <= 2;

        const atBottom = galleryTarget >= maxScroll - 2;

        /*
        * =====================================================
        * PRODUCT MEDIA SECTION VISIBILITY
        * =====================================================
        */

        const rect = gallerySection.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        const visibleTop =
            Math.max(
                rect.top,
                0
            );

        const visibleBottom =
            Math.min(
                rect.bottom,
                viewportHeight
            );

        const visibleHeight =
            Math.max(
                0,
                visibleBottom - visibleTop
            );

        /*
        * Actual percentage of the product media section
        * that is visible.
        */

        const sectionHeight = rect.height;

        const visibleRatio =
            sectionHeight > 0
                ? visibleHeight / sectionHeight
                : 0;

        /*
        * CHANGE THIS TO 0.60 OR 0.65 IF REQUIRED
        */

        const reverseVisibilityThreshold = 0.50;

        const galleryVisibleEnough =
            visibleRatio >=
            reverseVisibilityThreshold;

        const galleryInViewport =
            rect.bottom > 0 &&
            rect.top < viewportHeight;

        /*
        * =====================================================
        * GALLERY CURRENTLY OWNS SCROLL
        * =====================================================
        */

        if (galleryOwnsScroll) {

            /*
            * =================================================
            * DOWN
            * =================================================
            */

            if (isDown) {

                /*
                * User changed direction.
                */
                galleryReleasedAtTop = false;

                /*
                * LAST IMAGE
                */

                if (atBottom) {

                    galleryTarget = maxScroll;
                    galleryPosition = maxScroll;
                    wrapper.style.transform = `translate3d(0,-${maxScroll}px,0)`;
                    galleryOwnsScroll = false;
                    galleryEnteredFromBottom = false;
                    return;
                }

                /*
                * MOVE FORWARD
                */

                e.preventDefault();
                galleryTarget += delta;
                galleryTarget =
                    Math.min(
                        galleryTarget,
                        maxScroll
                    );


                if (!galleryFrame) {
                    galleryFrame = true;
                    requestAnimationFrame(animateGalleryScroll);
                }

                return;
            }

            /*
            * =================================================
            * UP / REVERSE
            * =================================================
            */

            if (isUp) {

                /*
                * =================================================
                * IMPORTANT FIX
                *
                * If the gallery is no longer sufficiently
                * visible, RELEASE control back to the page.
                * =================================================
                */

                if (
                    !galleryInViewport ||
                    !galleryVisibleEnough
                ) {

                    galleryOwnsScroll = false;
                    galleryEnteredFromBottom = false;

                    /*
                    * DO NOT preventDefault().
                    *
                    * Let the browser scroll the page upward.
                    */

                    return;
                }

                /*
                * =================================================
                * FIRST IMAGE
                * =================================================
                */

                if (atTop) {

                    galleryTarget = 0;
                    galleryPosition = 0;
                    wrapper.style.transform = "translate3d(0,0,0)";
                    galleryReleasedAtTop = true;
                    galleryOwnsScroll = false;
                    galleryEnteredFromBottom = false;

                    /*
                    * Let page scrolling continue.
                    */

                    return;
                }

                /*
                * =================================================
                * REVERSE IMAGE SCROLL
                * =================================================
                */

                e.preventDefault();
                galleryTarget -= delta;

                galleryTarget =
                    Math.max(
                        0,
                        galleryTarget
                    );

                if (!galleryFrame) {
                    galleryFrame = true;

                    requestAnimationFrame(
                        animateGalleryScroll
                    );
                }

                return;
            }
        }

        /*
        * =====================================================
        * GALLERY DOES NOT OWN SCROLL
        * =====================================================
        */

        /*
        * =====================================================
        * DOWN / TOP → BOTTOM
        * =====================================================
        */

        if (isDown) {
            galleryReleasedAtTop = false;

            /*
            * Gallery must be entering from the top.
            */

            const enteringFromTop =
                rect.top <= 120 &&
                rect.bottom > 0;

            if (!enteringFromTop) {
                return;
            }

            /*
            * Take control.
            */

            e.preventDefault();
            galleryOwnsScroll = true;
            galleryEnteredFromBottom = false;
            galleryTarget += delta;
            galleryTarget = Math.min(galleryTarget, maxScroll);

            if (!galleryFrame) {
                galleryFrame = true;
                requestAnimationFrame(animateGalleryScroll);
            }
            return;
        }

        /*
        * =====================================================
        * UP / BOTTOM → TOP
        * =====================================================
        */

        if (isUp) {

            /*
            * Already released at first image.
            */

            if (galleryReleasedAtTop) {
                return;
            }

            /*
            * =================================================
            * HARD CHECK
            *
            * Gallery MUST actually be inside viewport.
            * =================================================
            */

            if (!galleryInViewport) {
                return;
            }

            /*
            * =================================================
            * VISIBILITY CHECK
            *
            * Gallery must be at least the configured
            * percentage visible before reverse begins.
            * =================================================
            */

            if (!galleryVisibleEnough) {
                return;
            }

            /*
            * =================================================
            * START REVERSE MODE
            * =================================================
            */

            e.preventDefault();
            galleryOwnsScroll = true;
            galleryEnteredFromBottom = true;

            /*
            * Restore bottom gallery position if necessary.
            */

            if (galleryTarget <= 0) {
                galleryTarget = maxScroll;
                galleryPosition = maxScroll;
                wrapper.style.transform = `translate3d(0,-${maxScroll}px,0)`;
            }

            /*
            * Apply current upward wheel movement.
            */

            galleryTarget -= delta;

            galleryTarget = Math.max(0, galleryTarget);
            if (!galleryFrame) {
                galleryFrame = true;
                requestAnimationFrame(animateGalleryScroll);
            }

            return;
        }

    }, {
        passive: false
    });

    // --------------------------------
    // RESIZE
    // --------------------------------

    window.addEventListener('resize', function(){
        if(!gallerySwiper) return;
        gallerySwiper.update();
        removeSwiperHeights();
    });

    // --------------------------------
    // COLOR CHANGE
    // --------------------------------
    document.addEventListener("change", function(e){
        if(!e.target.matches('input[name^="Color"]')) return;
        loadGallery(e.target.value);
    });

    // --------------------------------
    // INITIAL COLOR
    // --------------------------------

    const selectedColor = document.querySelector('input[name^="Color"]:checked');
    if(selectedColor){
        loadGallery(selectedColor.value);
    }

    setTimeout(function(){
        if(!gallerySwiper) return;
        const wrapper = gallerySwiper.wrapperEl;
        galleryPosition = 0;
        galleryTarget = 0;
        galleryReady = true;
    }, 300);

    const liveContainer = document.querySelector("#live-search-products");
    const defaultProductsHTML = liveContainer.innerHTML;

    window.searchDictionary = [
        
        
            
            
            "ozel",
            
        
            
            
            "ozel bag",
            
        
            
            
            "the ozel bag",
            
        
            
            
            "amra",
            
        
            
            
            "amra hasli",
            
        
            
            
            "hasli",
            
        
            
            
            "floral",
            
        
            
            
            "flower",
            
        
            
            
            "flowers",
            
        
            
            
            "floral bag",
            
        
            
            
            "floral embroidered bag",
            
        
            
            
            "embroidered",
            
        
            
            
            "embroidery",
            
        
            
            
            "embroidered bag",
            
        
            
            
            "free",
            
        
            
            
            "fierce",
            
        
            
            
            "free and fierce",
            
        
            
            
            "free and fierce bag",
            
        
            
            
            "half",
            
        
            
            
            "moon",
            
        
            
            
            "half moon",
            
        
            
            
            "half moon clutch",
            
        
            
            
            "bag",
            
        
            
            
            "bags",
            
        
            
            
            "purse",
            
        
            
            
            "purses",
            
        
            
            
            "tote",
            
        
            
            
            "tote bag",
            
        
            
            
            "totes",
            
        
            
            
            "clutch",
            
        
            
            
            "clutches",
            
        
            
            
            "shoulder bag",
            
        
            
            
            "sling bag",
            
        
            
            
            "mini bag",
            
        
            
            
            "evening bag",
            
        
            
            
            "party bag",
            
        
            
            
            "statement bag",
            
        
            
            
            "designer bag",
            
        
            
            
            "luxury bag",
            
        
            
            
            "premium bag",
            
        
            
            
            "ethnic bag",
            
        
            
            
            "festive bag",
            
        
            
            
            "bridal bag",
            
        
            
            
            "wedding bag",
            
        
            
            
            "occasion bag",
            
        
            
            
            "black bag",
            
        
            
            
            "white bag",
            
        
            
            
            "beige bag",
            
        
            
            
            "gold bag",
            
        
            
            
            "silver bag",
            
        
            
            
            "pink bag",
            
        
            
            
            "green bag",
            
        
            
            
            "blue bag",
            
        
            
            
            "red bag",
            
        
            
            
            "fabric bag",
            
        
            
            
            "canvas bag",
            
        
            
            
            "cotton bag",
            
        
            
            
            "vegan leather",
            
        
            
            
            "leather",
            
        
            
            
            "jacquard",
            
        
            
            
            "handcrafted",
            
        
            
            
            "handmade",
            
        
            
            
            "artisan",
            
        
            
            
            "gift",
            
        
            
            
            "gifting",
            
        
            
            
            "travel",
            
        
            
            
            "office",
            
        
            
            
            "casual",
            
        
            
            
            "everyday bag",
            
        
            
            
            "julia",
            
        
            
            
            "julia bag",
            
        
            
            
            "julia baguette",
            
        
            
            
            "julia baguette bag",
            
        
            
            
            "julia baguette mini",
            
        
            
            
            "baguette",
            
        
            
            
            "baguette bag",
            
        
            
            
            "mini",
            
        
            
            
            "mini bag"
            
        
    ];

    $(document).off('focus.search input.search', '.custom_search_field').on('focus.search input.search', '.custom_search_field', function () {
        const $input = $(this);
        $input.addClass('focus-search');
        const $search = $input.closest('.header-search-field');
        $input.attr('placeholder', $input.attr('focusholder'));
        $search.addClass('search-active');
        $('body').addClass('default-search-parameters-open');
        $('.search-default-content').removeClass('hidden').addClass('active-default-terms');
    });

    $(document).off('click.search', '.search-no-trigger-btn').on('click.search', '.search-no-trigger-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $field = $(this).closest('.field');
        const $input = $field.find('.custom_search_field');
        $input.attr('placeholder', $input.attr('focusholder'));
        $('body').addClass('default-search-parameters-open');
        $('.search-default-content').removeClass('hidden').addClass('active-default-terms');
        if (document.activeElement !== $input[0]) {
            $input.trigger('focus');
            $input.addClass("focus-search");
        }

        // Move cursor to the end
        const input = $input[0];
        const length = input.value.length;
        input.setSelectionRange(length, length);
    });

    $(document).off('input.searchButtons', '.custom_search_field').on('input.searchButtons', '.custom_search_field', function () {
        const $field = $(this).closest('.field');
        const hasValue = $.trim($(this).val()).length > 0;
        $field.find('.reset__button').toggleClass('hidden', !hasValue);
        $field.find('.search-trigger-btn').toggleClass('hidden', !hasValue);
        $field.find('.search-no-trigger-btn').toggleClass('hidden', hasValue);
    });

    $(document).off('click.searchReset', '.reset__button').on('click.searchReset', '.reset__button', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $field = $(this).closest('.field');
        const $input = $field.find('.custom_search_field');
        $input.val('');
        $field.find('.search_query').val('');
        $(this).addClass('hidden');
        $field.find('.search-trigger-btn').addClass('hidden');
        $field.find('.search-no-trigger-btn').removeClass('hidden');

        // Keep focus only on this input
        if (document.activeElement !== $input[0]) {
            $input.trigger('focus');
            $input.addClass("focus-search");
        }
    });

    function prepareSearch(form) {
        if (!form) return "";
        const visibleInput = form.querySelector(".custom_search_field, .custom_search_field_2");
        const hiddenInput = form.querySelector(".search_query");
        if (!visibleInput || !hiddenInput) return "";
        const original = visibleInput.value.trim();
        const corrected = getClosestMatch(original, true);
        // display_q stays original
        visibleInput.value = original;
        // q gets corrected
        hiddenInput.value = corrected;
        return corrected;
    }

    function levenshtein(a, b) {
        if (a === b) return 0;
        const matrix = [];
        for (let i = 0; i <= b.length; i++) {
            matrix[i] = [i];
        }
        for (let j = 0; j <= a.length; j++) {
            matrix[0][j] = j;
        }
        for (let i = 1; i <= b.length; i++) {
            for (let j = 1; j <= a.length; j++) {
                if (b.charAt(i - 1) === a.charAt(j - 1)) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                } else {
                    matrix[i][j] = Math.min(
                        matrix[i - 1][j - 1] + 1,
                        matrix[i][j - 1] + 1,
                        matrix[i - 1][j] + 1
                    );
                }
            }
        }
        return matrix[b.length][a.length];
    }

    function getClosestMatch(query, forceCorrection = false) {
        query = query.trim().toLowerCase();
        if (!query) return "";
        const dictionary = window.searchDictionary.map(item => item.toLowerCase());
        // Exact phrase exists
        if (dictionary.includes(query)) {
            return query;
        }
        // Live search: don't autocorrect
        // Create a unique list of words from all dictionary phrases
        const dictionaryWords = [...new Set(
            dictionary.flatMap(item => item.split(/\s+/))
        )];

        // During typing, only complete prefixes
        if (!forceCorrection) {
            const words = query.split(/\s+/);
            const completedWords = words.map(function(word){
                if(word.length < 2)
                    return word;
                    const prefixMatches = dictionaryWords.filter(function(candidate){
                        return candidate.startsWith(word);
                    });

                    prefixMatches.sort(function(a,b){
                        return a.length - b.length;
                    });

                    return prefixMatches.length
                        ? prefixMatches[0]
                        : word;
            });
            return completedWords.join(" ");
        }

        // Correct every word
        const correctedWords = query.split(/\s+/).map(function(word) {

            // Ignore 1-2 character words
            if (word.length < 2) {
                return word;
            }

            const prefixMatches = dictionaryWords.filter(function(candidate) {
                return candidate.startsWith(word);
            });

            prefixMatches.sort(function(a, b) {
                return a.length - b.length;
            });

            if (prefixMatches.length) {
                return prefixMatches[0];
            }

            let bestMatch = word;
            let minDistance = Infinity;
            dictionaryWords.forEach(function(candidate) {
                const distance = levenshtein(word, candidate);
                if (distance < minDistance) {
                    minDistance = distance;
                    bestMatch = candidate;
                }
            });

            const threshold = Math.max(1, Math.floor(bestMatch.length * 0.35));
            return minDistance <= threshold ? bestMatch : word;
        });

        const correctedPhrase = correctedWords.join(" ");
        // Try matching the whole phrase
        let bestPhrase = correctedPhrase;
        let bestPhraseDistance = Infinity;
        dictionary.forEach(function(item) {
            const distance = levenshtein(correctedPhrase, item);
            if (distance < bestPhraseDistance) {
                bestPhraseDistance = distance;
                bestPhrase = item;
            }
        });

        const phraseThreshold = Math.max(1, Math.floor(bestPhrase.length * 0.20));
        return bestPhraseDistance <= phraseThreshold ? bestPhrase : correctedPhrase;
    }

    let timer;
    document.querySelectorAll(".custom_search_field").forEach(function(input){
        input.addEventListener("input", function(){
            clearTimeout(timer);
            const form = this.closest("form");
            const hiddenInput = form.querySelector(".search_query");
            const original = this.value.trim();

            if (original === "") {
                hiddenInput.value = "";
                document.querySelectorAll("#live-search-products").forEach(function(el){
                    el.innerHTML = defaultProductsHTML;
                });
                $(".search-default-l").show();
                return;
            }

            // Live search never autocorrects
            const query = getClosestMatch(original, true);
            hiddenInput.value = query;
            clearTimeout(timer);
            timer = setTimeout(function(){

                fetch(`/search?q=${encodeURIComponent(query)}&type=product&section_id=live-search-products`)
                    .then(res => res.text())
                    .then(html => {
                        document.querySelectorAll("#live-search-products").forEach(function(el){
                            el.innerHTML = html;
                        });

                        // Hide Best Selling Products section if no products
                        if ($("#live-search-products .search-item").length) {
                            $(".search-default-l").show();
                        } else {
                            $(".search-default-l").hide();
                        }
                    });
                },250
            );
        });
    });

    document.querySelectorAll(".search__form").forEach(function(form){
        form.addEventListener("submit", function(){
            prepareSearch(form);
        });
    });

    $('.search-default-content').on('mouseenter', function (e) {
        e.stopPropagation();
    });

    function closeSearch() {
        $('.header-search-field').removeClass('search-active');
        $('body').removeClass('default-search-parameters-open');
        $('.search-default-content').removeClass('active-default-terms').addClass('hidden');

        $('.custom_search_field').each(function () {
            $(this).val('');
            $(this).removeClass("focus-search");
        });

        $('.search_query').val('');
        $('.reset__button').addClass('hidden');
        $('.search-trigger-btn').addClass('hidden');
        $('.search-no-trigger-btn').removeClass('hidden');
    }

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.header-search-field').length) {
            closeSearch();
        }
    });

    $(document).on('click', '.close-search-parameter', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeSearch();
    });

    $(document).on('touchstart touchend click', '.product-image-slider .slick-dots button', function(e) {
      e.stopPropagation();
    });

});